import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { HteResult } from "@/components/hte/HteResult";
import { ProgramResult } from "@/components/program/ProgramResult";
import { CadanganPanel } from "@/components/hte/CadanganPanel";
import { ChainCrumbs } from "@/components/atas/Chain";
import { errMsg, useApi } from "@/lib/api";

export default function KajianPage() {
  const { id } = useParams();
  const api = useApi();
  const [kajian, setKajian] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api("get", `/kajian/${id}`).then(setKajian).catch((e) => setError(errMsg(e))); }, [api, id]);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-10 space-y-6">
      <Link to="/kajian" className="inline-flex items-center gap-2 text-sm text-mute hover:text-ink" data-testid="back-to-kajian-list"><ArrowLeft size={15} /> Ruang Kerja Saya</Link>
      {error ? <p className="text-warn" data-testid="kajian-error">{error}</p> : !kajian ? <Loader2 className="animate-spin text-q" /> :
        <><ChainCrumbs kajianId={kajian.id} />{kajian.jenis === "program" ? <ProgramResult kajian={kajian} setKajian={setKajian} /> : <><HteResult kajian={kajian} onUpdated={setKajian} />{kajian.cadangan && <CadanganPanel kajian={kajian} />}</>}</>}
    </div>
  );
}
